<mat-card class="chart-card">
  <mat-card-header class="chart-header">
    <mat-card-title>
      {{ "Total Energy Consumption (All MDB)" | translate }}
    </mat-card-title>

    <div class="period-toggle">
      <button
        type="button"
        class="period-button"
        [class.active]="period === 'week'"
        (click)="onPeriodChange('week')"
      >
        {{ "view_value.week" | translate }}
      </button>

      <button
        type="button"
        class="period-button"
        [class.active]="period === 'month'"
        (click)="onPeriodChange('month')"
      >
        {{ "view_value.month" | translate }}
      </button>
    </div>
  </mat-card-header>

  <mat-card-content>
    <div echarts class="daily-chart" [options]="chartOption"></div>
  </mat-card-content>
</mat-card>
